export const THEME_MEDIUM_WIDTH = 720;
export const THEME_LARGE_WIDTH = 1080;
export const THEME_LARGE_MAX_WIDTH = 1280;

export const THEME_BREAKPOINT = {
    width: {
        medium: THEME_MEDIUM_WIDTH,
        large: THEME_LARGE_MAX_WIDTH,
    },
    query: {
        small: `@media (max-width: ${THEME_MEDIUM_WIDTH}px)`,
        medium: `@media (min-width: ${THEME_MEDIUM_WIDTH}px)`,
        large: `@media (min-width: ${THEME_LARGE_WIDTH}px)`,
    },
    spacing: {
        small: 3,
        medium: 6,
        large: 8,
    },
};
